// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchInput_wrapper__PoyqH","wrapper_icon":"SearchInput_wrapper_icon__Gd7So","wrapper_input":"SearchInput_wrapper_input__UcTH9"};